import {
	FAIL_GET_JIGYOSHA_LIST_WD,
	GET_JIGYOSHA_LIST_WD,
	SUCCESS_GET_JIGYOSHA_LIST_WD,
	RESET_MASTER_JIGYOUSHA,
	RESET_PROCESS_ERROR,
	GET_JIGYOSHA,
	SUCCESS_GET_JIGYOSHA,
	FAIL_GET_JIGYOSHA,
	GET_JIGYOSHA_LIST,
	FAIL_GET_DENPYO_YOSHIKI_LIST,
	SUCCESS_GET_DENPYO_YOSHIKI_LIST,
	GET_KEIYAKU_KIGYOU_LIST,
	FAIL_GET_KEIYAKU_KIGYOU_LIST,
	SUCCESS_GET_KEIYAKU_KIGYOU_LIST,
	GET_ASN_RENKEI_LIST,
	FAIL_GET_ASN_RENKEI_LIST,
	SUCCESS_GET_ASN_RENKEI_LIST,
	CLEAR_JIGYOUSHA,
	SET_JIGYOSHA,
	SUCCESS_SET_JIGYOSHA,
	FAIL_SET_JIGYOSHA,
	DEL_JIGYOSHA,
	SUCCESS_DEL_JIGYOSHA,
	FAIL_DEL_JIGYOSHA,
	RESTORE_JIGYOSHA,
	FAIL_RESTORE_JIGYOSHA,
	SUCCESS_RESTORE_JIGYOSHA, UPDATE_MASTER_FLAG, FAIL_GET_JIGYOSHA_LIST, SUCCESS_GET_JIGYOSHA_LIST
} from '../../actions';

const initialState = {
	data:{
		"KanriKeiyakuKigyouCD":null,
		"JigyoushaName1":"",
		"JigyoushaShubetsu":"0",
		"DenpyoYoshikiCD":"1",
		"TorihikiKbn":"1",
		"JigyoushaKanriKbn":"1",
		"ElectronicReceiptFlg":"0",
		"MakerElectronicReceiptFlg":"0",
		"ERReceiverServiceDivide":"0",
		"ERMakerServiceDivide":"0",
	},
	isFetching: false,
	jigyoshaData:[],
	denpyoYoshikiData:[],
	keiyakukigyouData:[],
	asnRenkeiData:[],
	jigyoushaList:[],
	error: undefined,
	isProcessError : false,
	isCompleteUpdate : false,
	jigyoushaIsChanged : false

};
export default function masterJigyoshaSettings(state = initialState, action) {
	let ret = Object.assign({}, state, {});
    switch (action.type) {
		case GET_JIGYOSHA_LIST_WD:
			ret.isFetching = true;
			return ret;
		case FAIL_GET_JIGYOSHA_LIST_WD:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SUCCESS_GET_JIGYOSHA_LIST_WD:
			ret.jigyoshaData = action.payload.data.map(suggestion => ({
				value: suggestion.JigyoushaCD,
				label: suggestion.JigyoushaCD + ' : ' + suggestion.JigyoushaName + ((suggestion.DelFlag === "1") ? " (削除)" : ""),
				name : suggestion.JigyoushaName
			}));
			ret.isFetching = false;
			return ret;
		case GET_JIGYOSHA:
			ret.isFetching = true;
			return ret;
		case SUCCESS_GET_JIGYOSHA:
			if(action.payload.data){
				ret.data = action.payload.data;
			}
			else{
				ret.data = {};
			}
			ret.jigyoushaIsChanged = true;
			ret.isFetching = false;
			return ret;
		case FAIL_GET_JIGYOSHA:
			ret.isFetching = false;
			ret.isProcessError = true;
			return ret;
		case FAIL_GET_DENPYO_YOSHIKI_LIST:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SUCCESS_GET_DENPYO_YOSHIKI_LIST:
			ret.denpyoYoshikiData = action.payload.data;
			ret.denpyoYoshikiData = action.payload.data.map(suggestion => ({
				value: suggestion.DenpyoYoshikiCD,
				label: suggestion.DenpyoYoshikiCD + ' : ' + suggestion.DenpyoYoshikiName,
				name : suggestion.DenpyoYoshikiName
			}));
			ret.isFetching = false;
			return ret;
		case GET_KEIYAKU_KIGYOU_LIST:
		case GET_JIGYOSHA_LIST:
		case GET_ASN_RENKEI_LIST:
			ret.isFetching = true;
			return ret;
		case FAIL_GET_KEIYAKU_KIGYOU_LIST:
		case FAIL_GET_JIGYOSHA_LIST:
		case FAIL_GET_ASN_RENKEI_LIST:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SUCCESS_GET_KEIYAKU_KIGYOU_LIST:
			ret.keiyakukigyouData = action.payload.data.map(suggestion => ({
				value: suggestion.KeiyakuKigyouCD,
				label: suggestion.KeiyakuKigyouCD + ' : ' + suggestion.KeiyakuKigyouName,
				name : suggestion.KeiyakuKigyouName
			}));
			ret.isFetching = false;
			return ret;
		case SUCCESS_GET_JIGYOSHA_LIST:
			ret.jigyoushaList = action.payload.data;
			ret.isFetching = false;
			return ret;
		case SUCCESS_GET_ASN_RENKEI_LIST:
			ret.asnRenkeiData = action.payload.data.map(suggestion => ({
				value: suggestion.ASNRenkeiCD,
				label: suggestion.ASNRenkeiCD + ' : ' + suggestion.ASNCorporateName,
				name : suggestion.ASNCorporateName
			}));
			ret.isFetching = false;
			return ret;
		case SET_JIGYOSHA:
		case DEL_JIGYOSHA:
		case RESTORE_JIGYOSHA:
			ret.isFetching = true;
			return ret;
		case SUCCESS_SET_JIGYOSHA:
		case SUCCESS_DEL_JIGYOSHA:
		case SUCCESS_RESTORE_JIGYOSHA:
			ret.isCompleteUpdate = true;
			ret.jigyoshaData = action.payload.data.map(suggestion => ({
				value: suggestion.JigyoushaCD,
				label: suggestion.JigyoushaCD + ' : ' + suggestion.JigyoushaName + ((suggestion.DelFlag === "1") ? " (削除)" : ""),
				name : suggestion.JigyoushaName
			}));
			ret.isFetching = false;
			return ret;
		case FAIL_SET_JIGYOSHA:
		case FAIL_DEL_JIGYOSHA:
		case FAIL_RESTORE_JIGYOSHA:
			ret.isFetching = false;
			ret.isProcessError = true;
			return ret;
		case CLEAR_JIGYOUSHA:
			ret.isCompleteUpdate = false;
			ret.data = {
						"KanriKeiyakuKigyouCD":null,
						"JigyoushaName1":"",
						"JigyoushaShubetsu":"0",
						"DenpyoYoshikiCD":"1",
						"TorihikiKbn":"1",
						"JigyoushaKanriKbn":"1",
						"ElectronicReceiptFlg":"0",
						"MakerElectronicReceiptFlg":"0",
						"ERReceiverServiceDivide":"0",
						"ERMakerServiceDivide":"0",
						};
			ret.jigyoushaIsChanged = false;
			return ret;
		case RESET_MASTER_JIGYOUSHA:
			Object.keys(initialState).forEach((keys)=>{
				ret[keys] = initialState[keys];
			});
			return ret;
		case RESET_PROCESS_ERROR:
			ret.isProcessError = false;
			return ret;
		case UPDATE_MASTER_FLAG:
			return Object.assign({}, state, action.payload);
		default:
			return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/master/jigyousha.js